import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/talent',
    authDomain: 'authenticate.seek.com',
    clientDomain: 'hk.employer.seek.com',
    clientId: '9Y4DKSBERdQX4XSg4jDGqhFs39NoHnQ1',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    contactUs: {
        en: 'https://hk.jobsdb.com/en-hk/cms/employer/recruitment-tips-and-guides/',
    },
    siteName: siteNames.employer.seek.hk,
    zone: getZoneFromSite(siteNames.employer.seek.hk),
    brand: Brand.SEEK,
    product: Product.HIRER,
};
//# sourceMappingURL=hk_employer_seek_com.js.map